import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { EMPLOYEE_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateDeleteEmployee = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${EMPLOYEE_API}/${id}`);
};

const useDeleteEmployeeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteEmployee,
    ...queryParams,
  });

export default useDeleteEmployeeMutation;
